import * as React from "react";
import { useAppSelector } from "../../../store/hooks";
import { Button } from "antd";
import { formSet, formSetValue } from "./utils";
import { cloneDeep, get } from "lodash";
import { store } from "../../../store";
import { CpErrorWarning } from "./CpErrorWarning";
import { FormListFieldLabels } from "../formListFieldLabels";
import { CpLabel } from "./CpLabel";
import { CpDescription } from "./CpDescription";
import { CpFormItem } from "./CpFormItem";
import { PlusCircleOutlined } from "@ant-design/icons";
import { ReactSortable } from "react-sortablejs";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props extends React.PropsWithChildren {
  label?: string;
  name: string;
  description?: string;
  labels?: string[];
  factoryFn: () => any;
  children: any;
}
export const CpArrayObjectSortable: React.FC<Props> = ({ label, name, description, labels, factoryFn, children }) => {
  const { id } = useCpFormContext();
  const items: any[] = useAppSelector((state) => get(state, `form.instances.${id}.values.${name}`)) || [];

  function add() {
    const _items = cloneDeep(items);
    _items.push(factoryFn());
    formSetValue(id, name, _items);
    const form = store.getState().form.instances[id];
    const onBlurCounter = form.meta.onBlurCounter;
    formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
  }

  return (
    <CpFormItem>
      {label ? <CpLabel name={`skip`}>{label}</CpLabel> : null}
      {description ? <CpDescription>{description}</CpDescription> : null}
      {items.length < 1 || !labels ? null : (
        <FormListFieldLabels className={`mb-1`} fieldLabels={labels} hasRemoveButton ng />
      )}
      <ReactSortable
        handle=".drag-handle"
        className="flex flex-col"
        list={cloneDeep(items || [])}
        setList={(newState) => {
          formSetValue(id, name, cloneDeep(newState));
        }}
      >
        {items.map((item, index) => {
          return React.Children.map(children, (child) =>
            React.cloneElement(child as any, {
              key: item.id,
              name: name,
              item: item,
              index: index,
            }),
          );
        })}
      </ReactSortable>
      <Button block type={`dashed`} onClick={() => add()} iconPosition="start" icon={<PlusCircleOutlined />}>
        Add
      </Button>
      <CpErrorWarning name={`${name}root`} />
    </CpFormItem>
  );
};
